import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './ContactHeaderCopy.scss';

const ContactHeaderCopy: FC = () => {
    return (
        <>
            <h1 className={styles.formHeader}>
                <FormattedMessage id="contact.formHeader" defaultMessage="Contact 1stDibs" />
            </h1>
            <div className={styles.formCopy}>
                <FormattedMessage
                    id="contact.formCopy"
                    defaultMessage="Our dedicated specialists are here to help with answering your questions and assisting with order-related needs."
                />
            </div>
        </>
    );
};

export default ContactHeaderCopy;
